var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMoreIcon = function SvgMoreIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1973E8",
    fillRule: "evenodd",
    d: "M12 8a1.999 1.999 0 1 1 0-4 2 2 0 0 1 0 4Zm0 6a1.999 1.999 0 1 1 0-4 2 2 0 0 1 0 4Zm-2 4a2 2 0 1 0 4.001.001A2 2 0 0 0 10 18Z",
    clipRule: "evenodd"
  })));
};
export default SvgMoreIcon;